import { render } from "./OffcanvasMergeSession.vue?vue&type=template&id=583ae31c&scoped=true"
import script from "./OffcanvasMergeSession.vue?vue&type=script&lang=js"
export * from "./OffcanvasMergeSession.vue?vue&type=script&lang=js"

import "./OffcanvasMergeSession.vue?vue&type=style&index=0&id=583ae31c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583ae31c"]])

export default __exports__